import UserAuth from '@services/auth';
import { LocalStorage } from '@utils/storage';

const APP_SESSION_CONFIG_KEY = 'appSessionConfig';

interface AppSessionConfigState {
  kc_rf_tc: string | null;
  bn_cl_so?: number[];
  ds_tb_so?: string;
  ds_vw_so?: string;
}

/**
 * Reads the shared appSessionConfig blob, scoped to the current refresh token.
 * If the stored refresh token doesn't match the current one, the stale
 * blob is dropped and null is returned.
 */
const getAppSessionConfig = (): AppSessionConfigState | null => {
  const stored = LocalStorage.getItem(
    APP_SESSION_CONFIG_KEY,
  ) as unknown as AppSessionConfigState | null;

  if (!stored || stored.kc_rf_tc !== UserAuth.refreshToken) {
    if (stored) {
      LocalStorage.remove(APP_SESSION_CONFIG_KEY);
    }
    return null;
  }

  return stored;
};

/**
 * Merges a single field into the shared appSessionConfig blob and stamps it
 * with the current refresh token.
 */
const setAppSessionConfig = <K extends keyof Omit<AppSessionConfigState, 'kc_rf_tc'>>(
  key: K,
  value: AppSessionConfigState[K],
): void => {
  const existing = getAppSessionConfig();
  const state: AppSessionConfigState = {
    ...existing,
    kc_rf_tc: UserAuth.refreshToken,
    [key]: value,
  };
  LocalStorage.setItem(APP_SESSION_CONFIG_KEY, state as unknown as string);
};

export { getAppSessionConfig, setAppSessionConfig, APP_SESSION_CONFIG_KEY };
export type { AppSessionConfigState };
